<template>
  <LeadAlert variant="error" :title="$t('order_creation_blocked.title')" :data-testid="testid">
    <span class="tw:text-muted" style="text-wrap: pretty">{{ $t('order_creation_blocked.body') }}</span>
    <template v-if="supportEmail" #actions>
      <a :href="mailtoLink" class="tw:text-13 tw:font-medium tw:text-red-700" :data-testid="`${testid}-contact`">
        {{ supportEmail }}
      </a>
    </template>
  </LeadAlert>
</template>

<script setup lang="ts">
import { brand } from '@/config/brands';
/**
 * "You can't place an order yet" notice, shown wherever blocked order creation needs explaining
 * - Home and the signup wizard's completion step share this copy and layout by design.
 */
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import LeadAlert from '@/components/lead-design/LeadAlert.vue';

interface Props {
  companyName: string;
  testid?: string;
}

const props = withDefaults(defineProps<Props>(), { testid: 'setup-blocked-banner' });

const { supportEmail } = storeToRefs(useUserStore());
const mailtoLink = computed(() => {
  const subject = `${brand.name} Registration Error - ${props.companyName}`;
  return `mailto:${supportEmail.value}?subject=${encodeURIComponent(subject)}`;
});
</script>
